<div class="footer" >
    <div style="max-width: 900px;">
        <div class="logo">
            <img src="./assets/img/osteomedica-logo.webp" alt="">
        </div>
        <div class="footer-text">
            <div class="contact-bar">
                <div>
                    <img src="./assets/img/icons/map-marker-2-32.webp" alt="">
                    <span><a aria-label="Google maps" target="_blank" [href]="getGoogleMapsLink(dataJson['Adresse'])">{{dataJson['Adresse']}}</a></span>
                </div>
                <div>
                    <img src="./assets/img/icons/phone-68-32.webp" alt="">
                    <span><a aria-label="Telefonnummer" href="tel:021519424700">{{dataJson['Telefonnummer']}}</a></span>
                </div>
                <div>
                    <img src="./assets/img/icons/phone-13-32.webp" alt="">
                    <span><a href="fax:021519424172" aria-label="Fax-Nummer">{{dataJson['FaxNummer']}}</a></span>
                </div>
                <div>
                    <img src="./assets/img/icons/mail-32.webp" alt="">
                    <span><a aria-label="E-Mail Adresse" href="mailto:{{dataJson['EMail']}}">{{dataJson['EMail']}}</a></span>
                </div>
            </div>
            <div class="contact-bar">
                <!-- <h2>Rechliches</h2> -->
                <div style="justify-content: center; align-items: center;">
                    <a aria-label="Impressum" routerLink="/impressum" [routerLinkActive]="'active-link'">Impressum</a>
                    <span>|</span>
                    <a aria-label="Datenschutz" routerLink="/datenschutzerklaerung" [routerLinkActive]="'active-link'">Datenschutz</a>
                </div>
                <div style="justify-content: center; align-items: center;">
                    <span style="font-weight: 200; font-size: 16px; padding-bottom: 8px;">
                       {{ dataJson['Copyright'] }}
                    </span>
                </div>
                <div style="justify-content: center; align-items: center;">
                    <span style="font-weight: 200; font-size: 9px; padding-bottom: 8px;">
                        Webdesign by Stefan Horning
                    </span>
                </div>
            </div>
        </div>

    </div>
    
</div>